import {inject, Injectable} from '@angular/core';
import {ApiService, HttpShortHeaders, IAuthRequest, ILoginResponse} from '@core/api/data-access';
import {Observable} from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	public readonly apiService: ApiService = inject(ApiService);
	/* ----------------------------------------------- INDICATORS ----------------------------------------------- */

	/* -------------------------------------------------------------------------------------------------------------- */

	constructor() {}

	public login(request: IAuthRequest): Observable<ILoginResponse> {
		const headers: HttpShortHeaders = {
			'Content-Type': 'application/*+json',
			accept: 'application/json',
		};
		return this.apiService.post<ILoginResponse, IAuthRequest>('auth/connect', request, headers, {}, false);
	}

	/* -------------------------------------------------------------------------------------------------------------- */

	/* --------------------------------------------- Static Methods --------------------------------------------- */
}
